import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AnalyticsNavigation from "./AnalyticsNavigation";
import DateFilter from "./DateFilter";
import { Box } from "@mui/material";
import dayjs from "dayjs";

const AnalyticsLayout = () => {
  const location = useLocation();

  // ---- Global Filter State (shared across all analytics pages) ----
  // Default to "Last 3 months"
  const [selectedDateRange, setSelectedDateRange] = useState(() => {
    const today = dayjs();
    const start_date = today.subtract(3, "months").startOf("month").format("YYYY-MM-DD");
    const end_date = today.format("YYYY-MM-DD");
    return {
      label: "Last 3 months",
      start_date,
      end_date
    };
  });

  const handleDateRangeChange = (newRange) => {
    setSelectedDateRange(newRange);
  };

  // Hide DateFilter on detail pages
  const isDetailPage = location.pathname.includes("/details") ||
                       location.pathname.includes("/table") ||
                       location.pathname.includes("/fallback-details") ||
                       location.pathname.includes("/line-details");

  return (
    <Box sx={{ p: 3 }}>

      {/* Tabs */}
      <AnalyticsNavigation />

      {/* 🔥 Global Section Header: Left = Page title, Right = Filter */}
      {!isDetailPage && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}
        >
          {/* ⚠ IMPORTANT: Page headings will appear here dynamically */}
          <Box sx={{ width: "fit-content", display: "inline-block" }} id="page-title-container"></Box>

          {/* Global Date Filter */}
          <DateFilter onChange={handleDateRangeChange} value={selectedDateRange} />
        </Box>
      )}

      {/* Nested Page Content */}
      <Outlet context={{ selectedDateRange }} />
    </Box>
  );
};

export default AnalyticsLayout;
